import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlSignature } from '../common/apiEndPoint';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PreviousEnrollment } from './previousEnrollment';

@Injectable()
export class PreUniversityService {
  constructor(private httpClient: HttpClient, private urlSignature: UrlSignature) {}

  getPreviousEnrolment(personId: string): Observable<PreviousEnrollment> {
    const url = this.urlSignature.previousEnrollmentByIdUrl + personId;
    return this.httpClient.get(url).pipe(map((response) => response as PreviousEnrollment));
  }

  deletePreviousEnrolment(previousEnrollmentId: string) {
    const url = this.urlSignature.previousEnrollmentByIdUrl + previousEnrollmentId;
    this.httpClient.delete(url).subscribe((response) => {
      console.log(response);
    });
  }

  savePreuniversityDetails(previousEnrollment: PreviousEnrollment) {
    const url = this.urlSignature.previousEnrollmentByIdUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    let data = JSON.stringify(previousEnrollment);
    return this.httpClient.post(url, data, httpOptions).pipe(map((response) => response as Response));
  }
  
  sendWarningMessage(fullName: string, attendanceName: string, personId: string) {
    const url = this.urlSignature.warningMessageUrl + fullName + '/' + attendanceName + '/' + personId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.httpClient.post(url, httpOptions).pipe(map((response) => response as Response));
  }
}